module.exports = __webpack_public_path__ + "0.2443469849d460506d67.worker.js"